import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.039 20.988q2.049 0 3.853-.784a10.2 10.2 0 0 0 3.196-2.167 10.2 10.2 0 0 0 2.167-3.186 9.6 9.6 0 0 0 .784-3.863q0-2.049-.784-3.853a10.2 10.2 0 0 0-2.167-3.196 10.2 10.2 0 0 0-3.196-2.166 9.6 9.6 0 0 0-3.863-.785 9.6 9.6 0 0 0-3.862.785A10.2 10.2 0 0 0 2.98 3.939 10.3 10.3 0 0 0 .823 7.135a9.6 9.6 0 0 0-.784 3.853q0 2.05.784 3.863a10.2 10.2 0 0 0 2.167 3.186 10.2 10.2 0 0 0 3.186 2.167 9.6 9.6 0 0 0 3.863.784m-1.098-5.215a1 1 0 0 1-.46-.108 1.3 1.3 0 0 1-.403-.363l-2.46-3.02q-.108-.147-.177-.304a1 1 0 0 1-.059-.333q0-.333.226-.569a.73.73 0 0 1 .559-.245q.214 0 .382.089.175.088.363.333l1.99 2.569 4.186-6.726q.274-.45.706-.45.315 0 .569.205.255.195.254.54a.8.8 0 0 1-.078.333 4 4 0 0 1-.167.313l-4.607 7.265a1.1 1.1 0 0 1-.363.353.9.9 0 0 1-.461.118"
    }, null, -1)
  ])))
}
export default { render: render }